<!--  -->
<template>
  <div class="sub">
    <h3>我的订阅</h3>
    <div class="statrBtn">
      <span v-if="isVIP">
        <i style="color:#D32C3C;">订阅会员已开通,</i>
        有效期至：{{userobj.userPrivilege.subscribe}}
      </span>
      <span v-else>开启订阅会员，畅享更多特权！</span>
      <button @click="vipshow=true">{{isVIP?'我要续订':'马上开通'}}</button>
    </div>
    <div class="content">
      <div v-show="!addSubShow">
        <h4>订阅管理</h4>
        <div style="display:inline-block;margin-left:20px">
          <i class="el-icon-question" style="font-size:20px;color:#0f4d72;"></i>
          <div
            style="display:inline-block;font-size:14px;color:#0f4d72;margin-left:10px;vertical-align: middle;"
          >
            <p>通过简单的关键词设置，即可定时自动获取与您设置的关键词相关的海外行业招标信息。</p>
            <p>订阅信息将定时发送至您的邮箱及微信，敬请查收</p>
          </div>
        </div>
        <el-button type="primary" class="addsubBtn" @click="goList">
          <i class="el-icon-plus"></i>添加订阅
        </el-button>
        <el-table
          :data="tableData"
          :header-cell-style="{
            background: '#f1f5f7',
            color: '#999999',
          }"
          :row-style="TableRowStyle"
          fit
        >
          <el-table-column prop="usskeyword" label="关键词" min-width="250" align="left"></el-table-column>
          <el-table-column
            prop="area"
            label="地区"
            align="left"
            min-width="150"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="ussulabel"
            label="行业"
            align="left"
            min-width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="sendtype"
            label="接收方式"
            align="left"
            show-overflow-tooltip
            min-width="100"
          ></el-table-column>
          <el-table-column prop="ussnotkeyword" label="排除词" align="left" min-width="100"></el-table-column>
          <el-table-column prop="e" label="操作" align="left" min-width="90">
            <template slot-scope="scope">
              <div v-show="(isVIP ==false &&  scope.row.assist == 0) || isVIP">
                <el-button type="text" @click="handleEdit(scope.row)">修改</el-button>
                <el-button type="text" @click="handleDels(scope.row.ussubsid, scope.row.ussuid)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-show="done">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="currentChange"
            layout="prev, pager, next,jumper"
            :total="total"
            :page-size="10"
            background
            :current-page.sync="pages"
          ></el-pagination>
        </div>
      </div>
      <div class="addsub" v-show="addSubShow">
        <h4>{{ subText }}</h4>
        <div class="box" style="padding-left:14px;">
          <span style="font-size:14px;">
            <i style="color:red">*</i>关键词
          </span>
          <el-divider direction="vertical"></el-divider>
          <!-- <el-input
            placeholder="请输入关键词"
            v-model="gjc"
            clearable
            style="width:500px;"
            size="small"
            maxlength="30"
          ></el-input>-->
          <el-tag
            :key="index"
            v-for="(tag,index) in dynamicTagsPC"
            closable
            :disable-transitions="false"
            @close="handleDelPC(tag)"
          >{{ tag }}</el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisiblePC"
            v-model.trim="inputValuePC"
            ref="saveTagInputPC"
            size="small"
            @keyup.enter.native="$event.target.blur"
            @blur="handleInputConfirmPC"
            maxlength="6"
          ></el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInputPC">+ 添加关键词</el-button>
        </div>
        <div class="box line" style="width:100%">
          <span style="font-size:14px;">
            <i style="color:red">*</i>选择区域
          </span>
          <el-divider direction="vertical"></el-divider>
          <button class="allbtn" @click="qyall()" :class="areaActive == -1 ? 'tagActive' : ''">全部</button>
          <el-checkbox-group
            v-model="checkList"
            style="display:inline-block;margin-right:30px;"
            v-for="(item, index) in countryList"
            :key="index"
          >
            <span class="group">
              <el-checkbox :label="item[0]" @change="handleAll(item[0])"></el-checkbox>
              <el-dropdown :hide-on-click="false" v-show="isVIP">
                <span class="el-dropdown-link">
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <el-checkbox-group
                      v-model="country"
                      @change="select($event, items.nfid)"
                      v-for="(items, index) in item[1]"
                      :key="index"
                    >
                      <el-checkbox :label="items.chinesecountry">
                        {{
                        items.chinesecountry
                        }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
          </el-checkbox-group>
          <div class="tagList" v-show="isVIP">
            <el-tag v-for="tag in tags" :key="tag" closable @close="handleClose(tag)">{{ tag }}</el-tag>
          </div>
        </div>
        <div class="box line" style="width:100%;" v-show="isVIP">
          <span style="font-size:14px;">
            <i style="color:red;">*</i>选择行业
          </span>
          <el-divider direction="vertical"></el-divider>
          <ul>
            <li @click="hangye('全部')" :class="blbActive == -1 ? 'tagActive' : ''">全部</li>
            <li
              style="margin-bottom:15px;"
              v-for="(item, index) in toplist"
              :key="index"
              :class="blbActive == index ? 'tagActive' : ''"
              @click="hangye(item, index)"
            >{{ item }}</li>
          </ul>
        </div>
        <!-- <div class="box">
          <span style="font-size:14px;"
            ><i style="color:red">*</i>信息类型</span
          >
          <el-divider direction="vertical"></el-divider>
          <button
            class="allbtn"
            @click="xxall()"
            :class="blbActive == -1 ? 'tagActive' : ''"
          >
            全部
          </button>
          <el-checkbox-group v-model="checkedType" @change="handleChecked">
            <el-checkbox v-for="item in endlist" :label="item" :key="item">{{
              item
            }}</el-checkbox>
          </el-checkbox-group>
        </div>-->
        <div class="box" style="padding-left: 0px;margin-left: 33px;">
          <span style="font-size:14px;">标题排除词&nbsp;&nbsp;</span>
          <el-divider direction="vertical"></el-divider>
          <el-tag
            :key="index"
            v-for="(tag,index) in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleDel(tag)"
          >{{ tag }}</el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model.trim="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="$event.target.blur"
            @blur="handleInputConfirm"
            maxlength="6"
          ></el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加排除词</el-button>
        </div>
        <div class="box">
          <span style="font-size:14px;">
            <i style="color:red">*</i>接收方式
          </span>
          <el-divider direction="vertical"></el-divider>
          <el-checkbox-group v-model="receiveList" @change="handleReceive">
            <el-checkbox label="邮箱接收"></el-checkbox>
            <el-checkbox label="微信接收"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div style="margin-left:134px;margin-top:20px">
          <el-button
            type="primary"
            style="width:120px;"
            size="small"
            @click="addsub()"
            :disabled="btnstatus"
          >确定</el-button>
          <el-button style="width:120px" size="small" @click="closeAdd" class="close">返回</el-button>
        </div>
      </div>
    </div>
    <vip :userInfo="userobj" v-show="vipshow" @closeVIP="closeVIP" v-if="userobj"></vip>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import tool from '../../tool/tool'
import { API_1, Global } from '@/conf/api'
import vip from '@/components/vipMask.vue'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'subscribe',
  components: { vip },
  data() {
    //这里存放数据
    return {
      vipshow: false, //充值会员弹框
      subText: '添加订阅',
      tableData: [],
      addSubShow: false,
      pcc: null, //排除词
      endlist: [], //信息类型列表
      checkedType: [], //信息类型勾选
      countryList: [], //区域列表
      isAll: false,
      all: null,
      tagTemp: [],
      paichuList: [],
      checkList: [], //区域选择list
      country: [],
      tags: [],
      countrgion: null,
      dynamicTags: [],
      dynamicTagsPC: [],
      inputVisible: false,
      inputVisiblePC: false,
      inputValue: '',
      inputValuePC: '',
      uid: null,
      token: null,
      areaActive: '-1', //地域 样式active
      blbActive: '-1', //信息类型 样式active
      blbttype: '', //信息类型
      notkeyword: null, //排除词
      temp: [], //全选洲暂存
      isAdd: true, //添加还是修改的标识
      ussubsid: null, //修改订阅 当条订阅的id
      btnstatus: false, //提交按钮状态 提交以后不能再点
      emailIs: false, //是否绑定邮箱
      wxIs: false, //是否绑定微信
      receiveList: ['邮箱接收'], //接收选项
      isVIP: false, //是否是会员
      userobj: {}, //个人会员信息
      pages: 1,
      total: null,
      done: false, //是否有数据
      toplist: [], //行业列表
      hangyeName: '',
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    TableRowStyle({ row, rowIndex }) {
      //非订阅会员除第一条其他变灰色
      let rowBackground = {}
      if (!this.isVIP && row.assist != 0) {
        rowBackground.color = '#DADADA'
        return rowBackground
      }
    },
    hangye(val, index) {
      //行业筛选
      if (val == '全部') {
        this.blbActive = -1
        this.hangyeName = ''
      } else {
        this.blbActive = index
        this.hangyeName = val
      }
    },
    top() {
      //行业
      let params = {}
      this.axios
        .get(API_1 + Global.top, { params: params })
        .then((res) => {
          this.toplist = res.data.top
        })
        .catch((res) => {})
    },
    handleSizeChange(val) {
      //前往多少页
      this.pages = val
      this.getInfo()
    },
    currentChange(val) {
      this.pages = val
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.getInfo()
    }, //分页
    closeVIP(val) {
      this.vipshow = val
    },
    handleReceive(val) {
      let wxis = val.includes('微信接收')
      if (wxis) {
        if (this.wxIs == false)
          this.$confirm('您未绑定微信号, 是否前去绑定?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            cancelButtonClass: 'wxclosebtn',
            confirmButtonClass: 'wxconfirmbtn',
          })
            .then(() => {
              this.$router.push({
                path: 'user',
              })
            })
            .catch(() => {
              this.receiveList.map((val, index) => {
                if (val == '微信接收') {
                  this.receiveList.splice(index, 1)
                }
              })
            })
      }
    },
    handleEdit(row) {
      //修改订阅
      if (row.countychinesejson) {
        this.country = JSON.parse(row.countychinesejson)
        this.tags = JSON.parse(row.countychinesejson)
        this.areaActive = 0
      }
      if (row.usscountrgions && this.isVIP) {
        let json = eval('(' + row.usscountrgions + ')')
        this.countrgion = json['cou']
        this.tagTemp = json['cou']
        this.areaActive = 0
      }
      if (row.continent) {
        this.checkList = JSON.parse(row.continent)
        this.areaActive = 0
        let obj = {
          北美洲: '1',
          大洋洲: '2',
          非洲: '3',
          南美洲: '4',
          欧洲: '5',
          亚洲: '6',
        }
        //      var  str = ["a", "b", "c"];
        //     var index = str.indexOf("a");
        //     if(index>-1){//大于0 代表存在，
        //     str.splice(index,1);//存在就删除
        // }
        let temp = []
        this.checkList.map((val) => {
          temp.push(obj[val])
        })
        this.all = "{'cont':[" + temp + ']}'
      }
      if (row.ussulabel) {
        this.hangyeName = row.ussulabel
      }
      // this.countryList = []
      this.subText = '修改订阅'
      this.isAdd = false
      this.addSubShow = true
      //修改标识 添加为true
      this.ussubsid = row.ussubsid //订阅id
      this.gjc = row.usskeyword //排除词清空
      // this.checkedType = row.ussblbttype.split(',') //信息类型清空
      if (this.checkedType.length == this.endlist.length) {
        this.blbActive = -1
      } else {
        this.blbActive = 0
      }
      if (row.ussnotkeyword == '--' || row.ussnotkeyword == null) {
        this.dynamicTags = []
      } else {
        this.dynamicTags = row.ussnotkeyword.split(',') // 排除词清空
      }
      this.dynamicTagsPC = row.usskeyword.split(',')
      if (row.ussulabel == null) {
        this.blbActive = -1
      } else {
        let index = this.toplist.indexOf(row.ussulabel)
        this.blbActive = index
      }
      let temp = [] //地区数组临时
      let idlist = [] //地区id
      // if (row.countychinesejson == '全部' || row.countychinesejson == null) {
      //   this.countrgion = '全部'
      //   this.areaActive = -1
      // } else {
      //   row.nationalFlaglist.map((val) => {
      //     temp.push(val.chinesecountry)
      //     idlist.push(val.nfid)
      //   })
      //   this.countrgion = idlist
      //   //this.country = this.tags = row.countyrlist.split(',')
      //   this.country = this.tags = temp
      //   this.areaActive = 0
      // }
      let type = row.sendtype.split('、')
      this.receiveList = type
    },
    goList() {
      if (this.emailIs == false) {
        this.$message({
          message: '您尚未绑定邮箱，无法进行订阅。请在个人中心绑定邮箱后再试',
          type: 'warning',
          offset: 100,
        })
      } else if (this.isVIP) {
        if (this.total >= 300) {
          this.$message({
            message: '订阅会员最多只能添加300条订阅信息',
            type: 'warning',
            offset: 100,
          })
        } else {
          this.subText = '添加订阅'
          this.addSubShow = true
          this.isAdd = true
        }
      } else {
        if (this.total >= 1) {
          // this.$message({
          //   message: '非订阅会员最多只能添加1条订阅信息',
          //   type: 'warning',
          //   offset: 100,
          // })
          this.$confirm(
            '成为订阅会员，即可享受最多300组订阅及更多订阅特权?',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              cancelButtonClass: 'wxclosebtn',
              confirmButtonClass: 'wxconfirmbtn',
            }
          )
            .then(() => {
              this.vipshow = true
            })
            .catch(() => {})
        } else {
          this.subText = '添加订阅'
          this.addSubShow = true
          this.isAdd = true
        }
      }
    },
    handleDel(tag) {
      //删除排查词标签
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    handleDelPC(tag) {
      //删除排查词标签
      this.dynamicTagsPC.splice(this.dynamicTagsPC.indexOf(tag), 1)
    },
    handleDels(ussubsid, ussuid) {
      //删除订阅
      this.$confirm('您确定要删除该条订阅信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        cancelButtonClass: 'wxclosebtn',
        confirmButtonClass: 'wxconfirmbtn',
      })
        .then(() => {
          let params = this.$qs.stringify({
            ussuid: ussuid,
            ussubsid: ussubsid,
          })
          this.axios
            .post(API_1 + Global.delSub, params, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
            })
            .then((res) => {
              if (res.data.status == 1) {
                this.getInfo()
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error',
                  offset: 100,
                })
              }
            })
            .catch((res) => {
              this.$message({
                message: '网络连接失败，请刷新重试',
                type: 'error',
                offset: 100,
              })
            })
        })
        .catch(() => {})
    },
    showInputPC() {
      //删除排查词标签
      if (this.isVIP) {
        if (this.dynamicTagsPC.length >= 10) {
          this.$message({
            message: '会员最多添加10个关键词',
            type: 'warning',
            offset: 100,
          })
        } else {
          this.inputVisiblePC = true
          this.$nextTick((_) => {
            this.$refs.saveTagInputPC.$refs.input.focus()
          })
        }
      } else {
        if (this.dynamicTagsPC.length >= 5) {
          this.$message({
            message: '非订阅会员最多添加5个关键词',
            type: 'warning',
            offset: 100,
          })
        } else {
          this.inputVisiblePC = true
          this.$nextTick((_) => {
            this.$refs.saveTagInputPC.$refs.input.focus()
          })
        }
      }
    },
    showInput() {
      //删除排查词标签
      if (this.dynamicTags.length >= 5) {
        this.$message({
          message: '最多添加5个排除词',
          type: 'warning',
          offset: 100,
        })
      } else {
        this.inputVisible = true
        this.$nextTick((_) => {
          this.$refs.saveTagInput.$refs.input.focus()
        })
      }
    },
    handleInputConfirmPC() {
      //排除词输入 失焦
      let inputValue = this.inputValuePC
      if (inputValue == '') {
        this.inputVisiblePC = false
      } else if (inputValue.length < 2) {
        this.$message({
          message: '关键词请大于等于2个字',
          type: 'warning',
          offset: 100,
        })
      } else {
        if (inputValue) {
          this.dynamicTagsPC.push(inputValue)
        }
        this.inputVisiblePC = false
        this.inputValuePC = ''
      }
    },
    handleInputConfirm() {
      //排除词输入 失焦
      let inputValue = this.inputValue
      if (inputValue == '') {
        this.inputVisible = false
      } else if (inputValue.length < 2) {
        this.$message({
          message: '排除词请大于等于2个字',
          type: 'warning',
          offset: 100,
        })
      } else {
        if (inputValue) {
          this.dynamicTags.push(inputValue)
        }
        this.inputVisible = false
        this.inputValue = ''
      }
    },
    end() {
      //信息
      let params = {}
      this.axios
        .get(API_1 + Global.end, { params: params })
        .then((res) => {
          this.endlist = res.data.end
          this.blbttype = this.endlist.join('|')
        })
        .catch((res) => {})
    },
    select(val, name) {
      //val 中文名
      //name 国家id
      this.countrgion = []
      this.areaActive = 0
      this.tagTemp.push(name)
      this.tags = this.country
      //this.tags = this.tagTemp
      if (this.countrgion == '' || this.countrgion == '()') {
        this.countrgion = this.tagTemp
      } else {
        this.countrgion = this.countrgion.replace(/[()]/g, '')
        let temparr = this.countrgion + '|' + name
        this.countrgion = temparr
      }
    },
    handleClose(tag) {
      let name
      let tempList
      this.paichuList.forEach((item) => {
        if (item.chinesecountry == tag) {
          name = item.nfid
        }
      })
      tempList = this.countrgion
      tempList.forEach((item, i) => {
        if (item == name) {
          tempList.splice(i, 1) // 从下标 i 开始, 删除 1 个元素
        }
      })
      // if (this.countrgion == '' || this.countrgion == '()') {
      //   this.countrgion = '(' + this.tagTemp.join('|') + ')'
      // } else {
      //   tempList = tempList.join('|')
      //   console.log(tempList)
      //   this.countrgion = '(' + tempList + ')'
      // }
      this.countrgion = tempList
      this.tags.splice(this.tags.indexOf(tag), 1)
      if (this.tags.length == 0 && this.checkList.length == 0) {
        this.all = null
        this.areaActive = -1
        this.countrgion = '全部'
        this.country = []
      }
    },
    paichu() {
      //用于删除区域查询中英文对应国家
      //筛选洲际国家列表
      let params = {}
      this.axios
        .get(API_1 + Global.paichu, { params: params })
        .then((res) => {
          this.paichuList = res.data.data
        })
        .catch((res) => {})
    },
    xxall() {
      //信息全部
      this.blbActive = -1
      this.blbttype = '(' + this.endlist.join('|') + ')'
      this.checkedType = []
    },
    handleChecked(val) {
      //信息勾选框
      this.blbActive = 0
      this.blbttype = this.checkedType.join('|')
      //this.checkedType
      if (this.checkedType.length == 0) {
        this.blbActive = -1
        this.blbttype = this.endlist.join('|')
      }
    },
    qyall() {
      //区域全部
      this.tags = []
      this.all = null
      this.checkList = []
      this.areaActive = -1
      this.countrgion = '全部'
      this.country = []
    },
    handleAll(val) {
      //全选洲际
      // this.checkList
      if (this.countrgion == '全部') {
        //全选一个洲际 默认把全部状态清楚
        this.countrgion = null
      }
      //   new_arr = arr.filter(
      //   (x) => !to_remove.some((item) => arr.indexOf(x) === item)
      // )
      //1北美2大洋洲3非洲4南美洲5欧洲6亚洲
      let obj = {
        北美洲: '1',
        大洋洲: '2',
        非洲: '3',
        南美洲: '4',
        欧洲: '5',
        亚洲: '6',
      }
      //      var  str = ["a", "b", "c"];
      //     var index = str.indexOf("a");
      //     if(index>-1){//大于0 代表存在，
      //     str.splice(index,1);//存在就删除
      // }
      if (this.checkList.length == 0 && this.country.length == 0) {
        this.areaActive = -1
      } else {
        this.areaActive = 0
      }
      let temp = []
      this.checkList.map((val) => {
        temp.push(obj[val])
      })
      if (temp.length == 0) {
        this.all = null
      } else {
        this.all = "{'cont':[" + temp + ']}'
      }

      //this.all = temp.join('|')
      // if (this.all == null) {
      //   this.all = obj[val]
      // } else {
      //   this.all = this.checkList.join('|')
      //   console.log(this.all)
      //this.all = this.all + '|' + obj[val]
      // console.log(this.all)
      // let paichu = String(this.all).split('|')
      // let temp = paichu.indexOf(obj[val])
      // console.log(temp)
      // if (temp > -1) {
      //   paichu.splice(temp, 1)
      // }
      // // console.log('1111111111111')
      // console.log(paichu)
      //this.all = paichu.join('|')
      //let xxx = paichu.join('|')
      // console.log(xxx)
      //this.all = this.all + '|' + obj[val]
      // this.all = xxx
      //console.log(this.all)
      //this.temp = this.all
      //}
    },
    allCountry() {
      //筛选洲际国家列表
      let params = {}
      //Global.country
      this.axios
        .get(API_1 + Global.screenCountry, { params: params })
        .then((res) => {
          this.countryList = Object.entries(res.data.data)
          //this.temp = res.data.data
          this.countrgion = '全部'
        })
        .catch((res) => {})
    },
    addsub() {
      //添加新订阅
      //单个国家用区域字段拼，全部国家传‘全部’，洲全选用洲拼串
      let reg = /^\s*$/g
      let params
      let countrg
      //地区选全部的时候传“全部”，单选国家拼在{cou：[1,2,3]}
      if (this.countrgion == '全部' || this.countrgion == null) {
        countrg = null
      } else {
        countrg = "{'cou':[" + this.countrgion + ']}'
      }

      let continent
      //有全选洲的时候 传（洲|洲|洲），没有全选洲传null
      // if (this.all == null) {
      //   continent = this.all
      // } else {
      //   continent = '(' + this.all + ')'
      // }
      let pcc
      if (this.dynamicTags.length == 0) {
        pcc = null
      } else {
        pcc = this.dynamicTags.join('|')
      }
      //订阅方式 1微信 2邮箱 3微信加邮箱
      let receive
      if (this.receiveList.toString() == '微信接收') {
        receive = 1
      } else if (this.receiveList.toString() == '邮箱接收') {
        receive = 2
      } else if (
        this.receiveList.toString() == '邮箱接收,微信接收' ||
        this.receiveList.toString() == '微信接收,邮箱接收'
      ) {
        receive = 3
      }
      if (this.dynamicTagsPC.length == 0) {
        this.$message({
          message: '关键词不能为空',
          type: 'error',
          offset: 100,
        })
      } else if (this.receiveList.length == 0) {
        this.$message({
          message: '请选择订阅内容的接收方式',
          type: 'error',
          offset: 100,
        })
      } else {
        let gjc = this.dynamicTagsPC.join('|')
        if (this.isAdd) {
          //添加订阅
          params = this.$qs.stringify({
            ussulabel: this.hangyeName, //行业
            ussuid: this.uid,
            usskeyword: gjc, //关键词
            usscountrgions: countrg, //区域{"cou":[1,2]}
            // ussblbttype: this.blbttype, //信息类型
            Continent: this.all, //洲拼串
            ussnotkeyword: pcc, //排除词
            sendtype: receive,
          })
        } else {
          //修改订阅
          params = this.$qs.stringify({
            ussulabel: this.hangyeName, //行业
            ussubsid: this.ussubsid,
            ussuid: this.uid,
            usskeyword: gjc, //关键词
            usscountrgions: countrg, //区域{"cou":[1,2]}
            // ussblbttype: this.blbttype, //信息类型
            Continent: this.all, //洲拼串
            ussnotkeyword: pcc, //排除词
            sendtype: receive,
          })
        }
        this.axios
          .post(API_1 + Global.addSub, params, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          })
          .then((res) => {
            if (res.data.status == 1) {
              this.btnstatus = true
              this.$message({
                message: '添加成功',
                type: 'success',
                offset: 100,
                duration: 1000,
                onClose: () => {
                  //此处写提示关闭后需要执行的函数
                  this.addSubShow = false
                  this.getInfo()
                  this.btnstatus = false
                  this.gjc = null //排除词清空
                  this.checkedType = [] //信息类型清空
                  this.dynamicTags = [] // 排除词清空
                  this.dynamicTagsPC = []
                  //地区清空
                  this.tags = []
                  this.all = null
                  this.checkList = []
                  this.countrgion = '全部'
                  this.country = []
                  this.areaActive = -1
                  this.blbActive = -1
                  this.hangyeName = ''
                  this.receiveList = ['邮箱接收']
                  document.body.scrollTop =
                    document.documentElement.scrollTop = 0
                },
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                offset: 100,
              })
            }
          })
          .catch((res) => {
            this.$message({
              message: '网络连接失败，请刷新重试',
              type: 'error',
              offset: 100,
            })
          })
      }
    },
    closeAdd() {
      this.addSubShow = false
      this.gjc = null //排除词清空
      this.checkedType = [] //信息类型清空
      this.dynamicTags = [] // 排除词清空
      this.dynamicTagsPC = [] // 排除词清空
      //地区清空
      this.tags = []
      this.all = null
      this.checkList = []
      this.countrgion = '全部'
      this.tagTemp = []
      this.country = []
      this.areaActive = -1
      this.blbActive = -1
      this.hangyeName = ''
    },
    getInfo() {
      //订阅列表
      let params = this.$qs.stringify({
        ussuid: this.uid,
        pages: this.pages,
        nums: 10,
      })
      this.axios
        .post(API_1 + Global.subList, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((res) => {
          //val.countyrlist = val.countyrlist.join(',')
          if (res.data.status == 1) {
            if (res.data.data) {
              this.tableData = res.data.data.list
              this.total = res.data.data.total
              this.done = true
              this.tableData.map((valx) => {
                if (
                  valx.countychinesejson != null ||
                  (valx.continent != null && valx.continent != '[]')
                ) {
                  let area, zhou
                  if (valx.countychinesejson != null) {
                    area = JSON.parse(valx.countychinesejson).join(',')
                  } else {
                    area = ''
                  }
                  if (valx.continent != null && valx.continent != '[]') {
                    if (valx.countychinesejson != null) {
                      zhou = JSON.parse(valx.continent).join(',') + ','
                    } else {
                      zhou = JSON.parse(valx.continent).join(',')
                    }
                  } else {
                    zhou = ''
                  }
                  valx.area = zhou + area
                } else {
                  valx.area = '全部'
                }
                if (valx.ussnotkeyword == '') {
                  valx.ussnotkeyword = '--'
                }
                if (valx.sendtype == 1) {
                  valx.sendtype = '微信接收'
                } else if (valx.sendtype == 2) {
                  valx.sendtype = '邮箱接收'
                } else if (valx.sendtype == 3) {
                  valx.sendtype = '邮箱接收、微信接收'
                }
              })
            } else {
              this.tableData = []
              this.done = false
              this.total = 0
            }
          } else {
            this.done = false
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 100,
            })
          }
        })
        .catch((res) => {
          this.$message({
            message: res,
            type: 'error',
            offset: 100,
          })
        })
    },
    getUser() {
      let params = this.$qs.stringify({
        id: this.uid,
        code: this.token,
      })
      this.axios
        .post(API_1 + Global.userInfo, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((res) => {
          this.userobj = {
            head: res.data.data.spareusero,
            username: res.data.data.username,
            usergrade: res.data.data.usergrade,
            userPrivilege: res.data.data.userPrivilege,
          }
          if (res.data.data.userPrivilege != null) {
            this.isVIP = true
          } else {
            this.isVIP = false
          }
          if (res.data.data.useremail) {
            this.emailIs = true
          } else {
            this.emailIs = false
          }
          if (res.data.data.code2) {
            this.wxIs = true
          } else {
            this.wxIs = false
          }
        })
        .catch((res) => {
          this.$message({
            message: '网络连接失败，请刷新重试',
            type: 'error',
            offset: 100,
          })
        })
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.uid = tool.getCookie('user')
    this.token = tool.getCookie('qxchuhai')
    this.getUser()
    this.allCountry()
    // this.end()
    this.getInfo()
    this.paichu()
    this.top()
    this.$emit('status', 1)
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss">
.wxconfirmbtn {
  background: #0f4d72 !important;
  border-color: #0f4d72 !important;
  &:hover {
    background: #105e8c !important;
    border-color: #105e8c !important;
  }
}
.wxclosebtn {
  border: solid 1px #0f4d72;
  background: #fff;
  color: #0f4d72;
  &:hover {
    border: solid 1px #178cd1;
    color: #178cd1;
    background: #fff;
  }
}
</style>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.allbtn {
  margin-right: 20px !important;
  width: 75px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  color: #666;
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
  border: 1px solid #eee !important;
  &:hover {
    background: #0f4d72;
    color: #fff;
  }
}
.el-tag {
  margin-right: 20px;
}
.tagActive {
  // padding: 5px 10px;
  background: #0f4d72;
  color: #fff;
  &:hover {
    background: #105e8c;
  }
  // margin: 3px 0;
}
.el-divider--vertical {
  background: #0f4d72;
  width: 2px;
  opacity: 0.5;
  margin: 0 15px;
}
.el-dropdown-menu {
  /deep/.el-checkbox-group {
    display: block;
  }
}
.el-checkbox-group {
  display: inline-block;
}

.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: middle;
}
.el-dropdown-menu {
  height: 450px;
  overflow-x: scroll;
  width: 180px;
}
.sub {
  // width: 1610px;
  min-height: 810px;
  background-color: #ffffff;
  margin: 10px;
  padding-top: 30px;
  text-align: left;
  .statrBtn {
    float: right;
    color: #666;
    font-size: 14px;
    margin-right: 50px;
    button {
      color: #63370c;
      width: 150px;
      height: 34px;
      background: $VIP-Button; //变量
      border-radius: 17px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      cursor: pointer;
      margin-left: 10px;
    }
    button:hover {
      background: $VIP-Button-hover;
    }
  }
  /deep/.el-button {
    background: #0f4d72;
    border: 0;
    color: #fff;
    &:hover {
      background: #105e8c;
    }
  }
  /deep/.el-button--text {
    color: #0f4d72;
    background: transparent;
    &:hover {
      color: #178cd1;
      background: transparent;
    }
  }
  /deep/.el-input__inner:focus {
    border-color: #0f4d72;
  }
  /deep/ .el-table__empty-text {
    display: block;
    width: 500px;
    height: 385px;
    padding-top: 300px;
    background: url('../../assets/nothing.png') no-repeat center center;
    background-size: auto;
    font-size: 20px;
    box-sizing: border-box;
    color: #a3bed7;
  }
  h3 {
    width: 73px;
    height: 20px;
    font-family: MicrosoftYaHei;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 0px;
    color: #0f4d72;
    padding-left: 10px;
    border-left: 4px solid #0f4d72;
    margin-left: 50px;
    margin-bottom: 30px;
    display: inline-block;
  }
  .content {
    border-top: 1px solid #eee;
    padding-top: 40px;
    text-align: left;
    padding: 40px 50px 50px;
    .pagination {
      margin-top: 10px;
      border-radius: 6px;
      background: #eff4f8;
      padding: 15px 40px;
      text-align: center;
      /deep/li {
        background: #f4f4f4 !important;
        color: #666 !important;
      }
      /deep/.active {
        background: #0f4d72 !important;
        color: #fff !important;
      }
    }
    .addsub {
      /deep/.close {
        border: solid 1px #0f4d72;
        background: #fff;
        color: #0f4d72;
        &:hover {
          border: solid 1px #178cd1;
          color: #178cd1;
        }
      }
      .box {
        margin-left: 40px;
        border-bottom: 1px dotted #eeeeee;
        padding: 20px 0;
        ul {
          display: inline-block;
          // width: 855px;
          width: 57%;
          min-width: 670px;
          vertical-align: top;
          margin-top: -3px;
          li {
            display: inline-block;
            margin-right: 20px !important;
            width: 75px;
            height: 30px;
            line-height: 30px;
            cursor: pointer;
            border-radius: 4px;
            text-align: center;
            box-sizing: border-box;
            border: 1px solid #eee !important;
            font-size: 14px;
            &:hover {
              background: #0f4d72;
              color: #fff;
            }
          }
        }
        .el-tag {
          margin-right: 10px;
          background: #e7edf1;
          color: #333;
          border: 0;
          /deep/.el-tag__close {
            color: #333;
            &:hover {
              background: #fff;
            }
          }
        }
        /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
          background-color: #0f4d72;
          border-color: #0f4d72;
        }
        /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
          font-size: 14px;
          color: #606266;
        }
        /deep/.el-checkbox__inner:hover {
          border-color: #0f4d72;
        }
        /deep/.el-checkbox__input.is-focus .el-checkbox__inner {
          border-color: #0f4d72;
        }
        /deep/.el-checkbox-group {
          .group {
            .is-checked {
              .el-checkbox__label {
                color: #0f4d72;
              }
              .is-checked {
                .el-checkbox__inner {
                  background-color: #0f4d72;
                  border-color: #0f4d72;
                }
              }
            }
          }
        }
        .tagList {
          margin-left: 100px;
          margin-top: 10px;
          .el-tag {
            margin-right: 10px;
            background: #e7edf1;
            color: #333;
            border: 0;
            margin-bottom: 10px;
            /deep/.el-tag__close {
              color: #333;
              &:hover {
                background: #fff;
              }
            }
          }
        }
      }
      .line {
        /deep/.el-checkbox-group {
          display: block;
        }
      }
    }
    h4 {
      font-size: 16px;
      color: #333333;
      margin-bottom: 30px;
      display: inline-block;
    }
    .addsubBtn {
      float: right;
      width: 150px;
      // height: 34px;
      // background-color: #409eff;
      // border-radius: 5px;
      // color: #fff;
      // vertical-align: middle;
      // cursor: pointer;
      // &:hover {
      //   background-color: #0f4d72;
      font-size: 15px;
      &:hover {
        background: #105e8c;
      }
      // }
      i {
        margin-right: 10px;
      }
    }
  }
}
</style>
